import React, { useState, useEffect } from 'react';
import { useAuthContext } from '../context/AuthContext';
import useUserPokemons from '../hooks/Pokemons/useUserPokemon';
import useTaskManagement from '../hooks/Tasks/useTaskManagement';
import styles from '../styles/TaskForm.module.css';
import button from '../styles/Button.module.css'
import icon from '../styles/PokemonIcon.module.css'

const TaskForm = ({ onSuccess, onAction, selectedPokemon, showForm}) => {
    const { user } = useAuthContext();
    const { userPokemons, isLoading: isPokemonsLoading } = useUserPokemons();
    // const [selectedPokemon, setSelectedPokemon] = useState(null);
    // const [showForm, setShowForm] = useState(null);
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        difficulty: ''
    });
    const [error, setError] = useState('');
    const { addTask, isAddingTask } = useTaskManagement(user?.id, selectedPokemon);
    const [formErrors, setFormErrors] = useState({});


    // useEffect(() => {
    //     if (userPokemons?.length > 0 && !selectedPokemon) {
    //         setSelectedPokemon(userPokemons[0]);
    //     }
    // }, [userPokemons, selectedPokemon]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        
        // Validation en temps réel
        const validationErrors = validateInput({
            ...formData,
            [name]: value
        });
        setFormErrors(validationErrors);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        // Validation avant soumission
        const validationErrors = validateInput(formData);
        if (Object.keys(validationErrors).length > 0) {
            setFormErrors(validationErrors);
            return; // Arrête la soumission si des erreurs existent
        }

        try {
            if (!selectedPokemon) {
                throw new Error('Veuillez sélectionner un Pokémon');
            }

            const taskData = {
                title: formData.title,
                description: formData.description || '',
                difficulty: formData.difficulty,
                utilisateur: `/api/utilisateurs/${user.id}`,
                userPokemon: `/api/user_pokemons/${selectedPokemon.user_pokemon_id}`
            };

            console.log('Données du formulaire:', taskData);

            addTask(taskData);
            console.log('Tâche créée avec succès');

            setFormData({
                title: '',
                description: '',
                difficulty: ''
            });
            onSuccess();
        } catch (error) {
            console.error('Erreur complète:', error);
            setError(error.message);
        }
    };

    const validateInput = (input) => {
        const errors = {};
        if (input.title.length < 3) errors.title = "Titre trop court";
        if (input.difficulty === "") errors.difficulty = "Veuillez sélectionner une difficulté";
        if (input.title.length > 40) errors.title = "Titre trop long";
        if (input.description && input.description.length > 500) {
            errors.description = "Description trop longue";
        }
        return errors;
    };

    if (isPokemonsLoading) {
        return <div>Chargement...</div>;
    }

    return (
        <div className={`${styles.taskFormContainer}`}>
            <form onSubmit={handleSubmit} className={`${styles.container}`}>
                {error && <div className={styles.error}>{error}</div>}
                <div className={styles.formContainer}>
                    <div className={styles.formContent }>
                        <div className={styles.formGroup}>
                            <input
                                type="text"
                                id="title"
                                name="title"
                                placeholder='Titre de la tâche'
                                value={formData.title}
                                onChange={handleChange}
                                required
                            />
                            {formErrors.title && (
                                <div className={styles.fieldError}>{formErrors.title}</div>
                            )}
                        </div>
                        <div className={styles.separator}></div>

                        <div className={styles.formGroupDescription}>
                            <textarea
                                id="description"
                                name="description"
                                placeholder='Description de la tâche (Facultatif)'
                                value={formData.description}
                                onChange={handleChange}
                            />
                            {formErrors.description && (
                                <div className={styles.fieldError}>{formErrors.description}</div>
                            )}
                        </div>
                        <div className={styles.separator}></div>
                        <div className={styles.formHeader}>
                            {formErrors.difficulty && (
                                <div className={styles.fieldError}>{formErrors.difficulty}</div>
                            )}
                            <div className={`${styles.selectGroup} ${styles.difficulty}`}>
                                <select
                                    id="difficulty"
                                    name="difficulty"
                                    value={formData.difficulty}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Sélectionnez la difficulté</option>
                                    <option value="easy">Facile</option>
                                    <option value="medium">Moyen</option>
                                    <option value="hard">Difficile</option>
                                </select>
                            </div>

                            {/* <div className={`${styles.selectGroup} ${styles.pokemon}`}>
                                <select
                                    id="pokemon"
                                    name="pokemon"
                                    value={selectedPokemon?.user_pokemon_id || ''}
                                    onChange={(e) => {
                                        const pokemon = userPokemons.find(p => p.user_pokemon_id.toString() === e.target.value);
                                        setSelectedPokemon(pokemon);
                                    }}
                                    required
                                >
                                    {userPokemons.map(pokemon => (
                                        <option key={pokemon.user_pokemon_id} value={pokemon.user_pokemon_id} className={icon.icon}>
                                            <p>{pokemon.nom}</p>
                                            <img src={pokemon.icon} alt={pokemon.nom} />
                                        </option>
                                    ))}
                                </select>
                            </div> */}
                        </div>
                    </div>
                </div>
            </form>
            <div className={`${styles.buttonContainer}`}>
                <button 
                    type="submit" 
                    onClick={handleSubmit}
                    disabled={isAddingTask}
                >
                    <div className={styles.button}
                    style={{
                        backgroundColor: 'rgb(6, 202, 88)',
                        border: '4px solid rgb(9, 168, 59)'
                    }}
                    >
                        {isAddingTask ? 'Création...' : 'Valider'}</div>
                </button>
                <button 
                    type="button"
                    onClick={() => {
                        onAction('cancel');
                        setFormData({  // On réinitialise le formulaire à chaque retour
                            title: '',
                            description: '',
                            difficulty: ''
                        });
                    }}
                >
                    <div className={styles.button} style={{
                        border: '4px solid rgba(95, 95, 95, 0.35)',
                        color:' rgb(95, 95, 95, 0.55)'
                    }}>Annuler</div>
                </button>
            </div>
        </div>
    );
};


export default TaskForm;